import { render, staticRenderFns } from "./UserRoleDetails.vue?vue&type=template&id=6f806fde&scoped=true"
import script from "./UserRoleDetails.vue?vue&type=script&lang=js"
export * from "./UserRoleDetails.vue?vue&type=script&lang=js"
import style0 from "./UserRoleDetails.vue?vue&type=style&index=0&id=6f806fde&prod&lang=scss"
import style1 from "./UserRoleDetails.vue?vue&type=style&index=1&id=6f806fde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f806fde",
  null
  
)

export default component.exports